module.exports = __webpack_public_path__ + "assets/5df651d3ce8ef4c82034090446a8f2bf.png";